module.exports = __webpack_public_path__ + "static/media/c-low-carbs.2b0093b4.jpg";